module.exports = __webpack_public_path__ + "media/images/flags/32/Bermuda-63abd5d83534cd4ce5d7edb59fad10ad.png";